/* global angular, $ */
(function () {
  "use strict";

  angular.module("app.floorplandetailrevamped").controller("floorplanDetailRevampedCtrl", [
    "$scope",
    "$window",
    "$timeout",
    "$rootScope",
    "$sce",
    "regionStorageFactory",
    "DataService",
    "slickConfigService",
    function (
      $scope,
      $window,
      $timeout,
      $rootScope,
      $sce,
      regionStorageFactory,
      DataService,
      slickConfigService,
    ) {
      $scope.planLoaded = false;
      $scope.images;
      $scope.showZoom = true;
      var loadedOnce = false;
      $scope.hasGalleryAssets = true;
      $scope.floorplansModal = false;
      $scope.galleryModal = false;

      var promiseUrl = $window.location.href;
      var params = '';
      var region = regionStorageFactory.get();

      $scope.regionUrl = region ? region.url : null;
      $scope.regionName = region ? region.name : '';
      $scope.regionSelected = !!region;

      var regionId = region ? region.id : null;

    function formatRange(low, high) {
      let hasLow  = low && low > 0;
      let hasHigh = high && high > 0;

      if (hasLow && hasHigh) {
        return low === high
          ? high.toLocaleString('en-US')
          : `${low.toLocaleString('en-US')}–${high.toLocaleString('en-US')}`;
      } else if (hasLow) {
        return low.toLocaleString('en-US');
      } else if (hasHigh) {
        return high.toLocaleString('en-US');
      } else {
        return "";
      }
    }

      if(regionId){
        params += 'region_id=' + regionStorageFactory.get().id;
      }

      if(params){
        promiseUrl += '?' + params;
      }

      $scope.floorplanPromise = DataService.getData(promiseUrl)
        .promise.then(function (response) {
          var floorplan = response.plan;
          $scope.collectionUrl = floorplan.collection && floorplan.collection.url ? floorplan.collection.url : false;
          $scope.collectionName = floorplan.collection && floorplan.collection.name ? floorplan.collection.name : 'Collection';
          $scope.youMightAlsoLike = response.you_might_also_like;
          $scope.hasYouMightAlsoLike = $scope.youMightAlsoLike && $scope.youMightAlsoLike.length > 0;
          $scope.$broadcast("user-selected-floorplan", floorplan);

          if ($scope.regionId && floorplan.communities.length > 0) {
            var prices = floorplan.communities
              .filter(c => c.region_id == $scope.regionId && c.min_price > 0)
              .map(c => c.min_price);

            if (prices.length) {
              var price = Math.min(...prices);
              $scope.setPrice(price);
            }
          }

          floorplan.beds = formatRange(floorplan.bed_low, floorplan.bed_high);
          floorplan.baths = formatRange(floorplan.bath_low, floorplan.bath_high);
          floorplan.sqft = formatRange(floorplan.sqft_low, floorplan.sqft_high);
          floorplan.stories = floorplan.floors 

          $scope.floorplan = floorplan;
          $scope.floorplan.model_homes =
            floorplan.model_homes !== undefined
              ? floorplan.model_homes
              : floorplan.modelHomes;

          $scope.planLoaded = true;

          $scope.floorplans = $scope.floorplan.floorplans ? $scope.floorplan.floorplans : false;

          return floorplan;
        })
        .then(function () {
          $scope.imagesLoaded = true;
          loadedOnce = true;

          $scope.hasInteractiveFloorplan = !!$scope.floorplan.interactive_floorplan_url;

          $scope.hasKitchenVisualizer = !!$scope.floorplan.kitchen_visualizer_url;
          $scope.kitchenVisualizerThumb = $scope.hasKitchenVisualizer && $scope.floorplan.visualizerThumb && $scope.floorplan.visualizerThumb.hd ? $scope.floorplan.visualizerThumb.hd : '/images/site/global/kitchen_visualizer_avery.gif';

          //Virtual Tour Logic
          let virtualTourUrl = $scope.floorplan.virtual_tour_url || '';

          if(virtualTourUrl && virtualTourUrl.indexOf('matterport') !== -1){
              const separator = virtualTourUrl.indexOf("?") === -1 ? "?" : "&";
              virtualTourUrl += separator + "play=1";
          }

          $scope.floorplan.virtualTourTrustedUrl = $sce.trustAsResourceUrl(virtualTourUrl);
          $scope.floorplan.interactiveFloorplanTrustedUrl = $scope.floorplan.interactive_floorplan_url ? $sce.trustAsResourceUrl($scope.floorplan.interactive_floorplan_url) : null;
          $scope.hasVirtualTour = !!$scope.floorplan.virtual_tour_url;
          
          // Gallery Carousel Config & Hero Assets
          $scope.hasGalleryAssets = $scope.floorplan.assets && $scope.floorplan.assets.length > 0;
          $scope.galleryAssets = $scope.floorplan.assets;
          if($scope.floorplan.videos && $scope.floorplan.videos.length > 0){
            $scope.galleryAssets.splice(3,0, $scope.floorplan.videos[0]);
            $scope.galleryAssets = $scope.galleryAssets.concat($scope.floorplan.videos.slice(1));
          }
          slickConfigService.modalSlideshow($scope);

          $scope.galleryStrip = {};
          $scope.galleryStrip.heroThumbnail =
            $scope.floorplan.assets &&
            $scope.floorplan.assets.length > 0 &&
            $scope.floorplan.assets[0].image
              ? $scope.floorplan.assets[0].image.hd
              : '';

          
          $scope.galleryStrip.videoFallback =
            $scope.floorplan.assets &&
            $scope.floorplan.assets.length > 3 &&
            $scope.floorplan.assets[3].image
              ? $scope.floorplan.assets[3].image.hd
              : '';
          $scope.galleryStrip.videoThumbnail = 
            $scope.floorplan.videos && 
            $scope.floorplan.videos.length > 0 &&
            $scope.floorplan.videos[0].image
              ? $scope.floorplan.videos[0].image.hd
              : $scope.galleryStrip.videoFallback;

          $scope.galleryStrip.virtualTourFallback =
            $scope.floorplan.assets &&
            $scope.floorplan.assets.length > 1 &&
            $scope.floorplan.assets[1].image
              ? $scope.floorplan.assets[1].image.hd
              : '';
          $scope.galleryStrip.virtualTourThumbnail = 
            $scope.floorplan.virtualTourThumb && $scope.floorplan.virtualTourThumb.original
              ? $scope.floorplan.virtualTourThumb.original
              : $scope.galleryStrip.virtualTourFallback;

          $scope.galleryStrip.galleryImageThumbnail =
            $scope.floorplan.assets &&
            $scope.floorplan.assets.length > 2 &&
            $scope.floorplan.assets[2].image
              ? $scope.floorplan.assets[2].image.hd
              : '';

          $scope.galleryStrip.viewAllThumbnail =
            $scope.floorplan.assets &&
            $scope.floorplan.assets.length > 4 &&
            $scope.floorplan.assets[4].image
              ? $scope.floorplan.assets[4].image.hd
              : '';

          $scope.galleryStrip.imageCount = $scope.floorplan.assets.length ? `${$scope.floorplan.assets.length}+` : 'All';

          
          // Collection Carousel Config
              
          $scope.floorplan.collectionSlide = slickConfigService.baseConfig(3);
          $scope.floorplan.collectionSlide.slidesToScroll = 1;
          $scope.floorplan.collectionSlide.arrows = true;

          var slickResponsive = [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                arrows: false,
                dots: true,
              },
            },
          ];

          $scope.floorplan.collectionSlide.responsive = slickResponsive;

          $scope.floorplan.collectionSlide.prevArrow = '<button type="button" class="floorplans-slick-btn slick-next"><svg class="icon-angle-left" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="12 0.5 11.5 0 0.1 11.4 11.5 22.8 12 22.4 1 11.4 "></polygon></svg></button>';
          $scope.floorplan.collectionSlide.nextArrow = '<button type="button" class="floorplans-slick-btn slick-prev"><svg class="icon-angle-right" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="0.1 0.5 0.5 0 12 11.4 0.5 22.8 0.1 22.4 11.1 11.4 "></polygon></svg></button>';


          // Elevations Carousel Config
          
          $scope.floorplan.elevationSlide = slickConfigService.baseConfig(3);
          $scope.floorplan.elevationSlide.infinite = true;

          $scope.floorplan.elevationSlide.responsive = slickResponsive;

          $scope.floorplan.elevationSlide.slidesToScroll = 1;

          $scope.floorplan.elevationSlide.arrows = true;
          $scope.floorplan.elevationSlide.prevArrow = '<button type="button" class="floorplans-slick-btn slick-next"><svg class="icon-angle-left" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="12 0.5 11.5 0 0.1 11.4 11.5 22.8 12 22.4 1 11.4 "></polygon></svg></button>';
          $scope.floorplan.elevationSlide.nextArrow = '<button type="button" class="floorplans-slick-btn slick-prev"><svg class="icon-angle-right" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="0.1 0.5 0.5 0 12 11.4 0.5 22.8 0.1 22.4 11.1 11.4 "></polygon></svg></button>';

          function addAutoPlay(url) {
            if(url && url.indexOf('matterport') !== -1) {
              const separator = url.indexOf("?") === -1 ? "?" : "&";
              url += separator + "play=1";
            }
            return url;
          };

          $scope.floorplan.virtualTourCarousel = [];
          
          function addTour(title = "", thumb = "", url, autoplay = false) {
            if (url) {
              $scope.floorplan.virtualTourCarousel.push({
                virtual_tour_title: title,
                virtualTourThumb: thumb,
                virtual_tour_url: $sce.trustAsResourceUrl(
                  autoplay ? addAutoPlay(url) : url
                )
              });
            }
          }

          addTour(
            $scope.floorplan.virtual_tour_title,
            $scope.floorplan.virtualTourThumb,
            $scope.floorplan.virtual_tour_url,
            true
          );
          
          addTour(
            $scope.floorplan.virtual_tour_b_title,
            $scope.floorplan.virtualTourBThumb,
            $scope.floorplan.virtual_tour_b_url
          );
          
          addTour(
            $scope.floorplan.virtual_tour_c_title,
            $scope.floorplan.virtualTourCThumb,
            $scope.floorplan.virtual_tour_c_url
          );
          

          $scope.floorplan.virtualtourSlide = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            swipe: true,
            dots: false,
            focusOnSelect: true,
            initialSlide: 0,
            asNavFor: '#virtual-tour-nav',
            prevArrow: '<button type="button" class="floorplans-slick-btn slick-prev"><svg class="icon-angle-left" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="12 0.5 11.5 0 0.1 11.4 11.5 22.8 12 22.4 1 11.4 "></polygon></svg></button>',
            nextArrow: '<button type="button" class="floorplans-slick-btn slick-next"><svg class="icon-angle-right" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="0.1 0.5 0.5 0 12 11.4 0.5 22.8 0.1 22.4 11.1 11.4 "></polygon></svg></button>'
          };
          
          $scope.floorplan.virtualtourNav = {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            swipeToSlide: true,
            asNavFor: '#virtual-tour-main',
            focusOnSelect: true,
            centerMode: true,
            centerPadding: '0px',
            variableWidth: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: { slidesToShow: 3 }
              },
              {
                breakpoint: 768,
                settings: { slidesToShow: 2 }
              },
              {
                breakpoint: 480,
                settings: { slidesToShow: 1 }
              }
            ]
          };

          $scope.slideChanged = function (event, slick, currentSlide) {
            if (document.activeElement) {
              document.activeElement.blur();
            }
          
            $('#virtual-tour-nav').slick('slickGoTo', currentSlide);
            if (currentSlide !== 0) {
          
              var firstIframe = $('.slick-slide[data-slick-index="0"]:not(.slick-cloned) iframe');
          
              if (firstIframe.length) {
          
                var iframe = firstIframe[0];
                var src = iframe.src;
                iframe.src = '';
                iframe.removeAttribute('src');
                iframe.offsetHeight;
                iframe.src = src.replace('autoplay=1', 'autoplay=0');
              }
            }
          };
          
          $scope.floorplan.floorplansSlide = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,      
            variableWidth: false, 
            arrows: true,
            dots: true,
            appendDots: '.floorplan-names',
            prevArrow: '<button type="button" class="floorplans-slick-btn slick-prev"><svg class="icon-angle-left" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="12 0.5 11.5 0 0.1 11.4 11.5 22.8 12 22.4 1 11.4 "></polygon></svg></button>',
            nextArrow: '<button type="button" class="floorplans-slick-btn slick-next"><svg class="icon-angle-right" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="0.1 0.5 0.5 0 12 11.4 0.5 22.8 0.1 22.4 11.1 11.4 "></polygon></svg></button>',
            customPaging: function (slider, i){
              var plan = $scope.floorplans[i];
              return '<button type="button">'+ (plan.title || 'Slide ' + (i+1)) +'</button>';
            },
          };

        });

      $scope.openCarouselModal = function(index, assets){
        $scope.setSlide(index);
        if (assets == 'floorplans'){
          $scope.newAssets = $scope.floorplans ? $scope.floorplans : [];
          $scope.slickLarge.dots = true;
          $scope.slickLarge.swipe = false;
          $scope.slickLarge.draggable = false;
          $scope.slickLarge.customPaging =  function (slider, i){
              var plan = $scope.floorplans[i];
              return '<button type="button">'+ (plan.title || 'Slide ' + (i+1)) +'</button>';
            };
          $scope.floorplansModal = true;
          $scope.galleryModal = false;
        } else {
          $scope.newAssets = $scope.galleryAssets ? $scope.galleryAssets : [];
          $scope.slickLarge.dots = false;
          $scope.floorplansModal = false;
          $scope.galleryModal = true;
        }
      }

      $scope.regionPhone =
        regionStorageFactory.getRegionPhone() || "1-855-342-2281";

      $scope.regionId = regionStorageFactory.get().id;

      $scope.$watch("regionId", function (is, was) {
        if (is == was) return;
      });

      $scope.navigate = function(url) {
        if(!url) return;
        $window.location.href = url;
      }

      $scope.regionFilter = function (community) {
        // Dont' fail if there is some reason we don't have a Region selected
        if (!$scope.regionId) {
          return community;
        }

        // Support "Greater Cincinnati" communities
        if ($scope.regionId == 1) {
          if (
            community.region_id == 1 ||
            Math.floor(community.region_id / 10) == 1
          ) {
            return community;
          }
        }

        // Support normal communities
        return community.region_id == $scope.regionId ? community : false;
      };

      $scope.setPrice = function (price) {
        $scope.floorplanPromise.then(function () {
          $scope.floorplan.price = price;
        });
      };

      $rootScope.$on("modalClose", function () {
        $scope.triggerSlick = false;
        $scope.galleryModal = false;
        $scope.floorplansModal = false;
      });


      $scope.setSlide = function(num) {
        $scope.slickLarge.initialSlide = num;
        $scope.slickLarge.method = {};
        $scope.slickLarge.event = {
            init: function (event, slick) {
              $scope.currentSlide = num;
            },
            afterChange: function (event, slick, currentSlide, nextSlide) {
              $scope.currentSlide = slick.currentSlide;
            }
        };
        $scope.triggerSlick = true;
      };
      $scope.floorplanDetailAnalyticsConfig = {
        googleAnalytics: {
          pageViewUrl: "/ajax-goals/qsu-floorplan-detail",
        },
      };

      /**
       * @todo Identify the scope and impact of migrating this to a dynamic
       * list, then migrate to a dynamically driven list of regions.
       */
      $scope.allRegions = {
        47: { order: 1, id: 47, name: "Atlanta, GA", url: "atlanta/georgia" },
        22: { order: 2, id: 22, name: "Columbus, OH", url: "columbus/ohio" },
        35: {
          order: 3,
          id: 35,
          name: "Indianapolis, IN",
          url: "indianapolis, indiana",
        },
        56: {
          order: 4,
          id: 56,
          name: "Lexington, KY",
          url: "lexington-kentucky",
        },
        48: {
          order: 5,
          id: 48,
          name: "Louisville, KY",
          url: "louisville/kentucky",
        },
        51: { order: 6, id: 51, name: "St. Louis, MO", url: "st-louis" },
        16: { order: 7, id: 16, name: "Dayton, OH", url: "dayton/ohio" },
        1: { order: 8, id: 1, name: "Cincinnati", url: "cincinnati-area/ohio" },
        11: {
          order: 9,
          id: 11,
          name: "Cincinnati, OH",
          url: "cincinnati/ohio",
        },
        13: {
          order: 10,
          id: 13,
          name: "Northern Kentucky",
          url: "northern-kentucky",
        },
        54: {
          order: 11,
          id: 54,
          name: "Northwest Florida",
          url: "northwest-florida",
        },
        55: {
          order: 12,
          id: 55,
          name: "Raleigh, NC",
          url: "raleigh/north-carolina",
        },
        14: {
          order: 13,
          id: 14,
          name: "Southeastern Indiana",
          url: "southeastern-indiana",
        },
      };

      $scope.regionPrice = function (region_id) {
        if (typeof $scope.floorplan === "undefined") return;
        if (typeof $scope.floorplan.communities === "undefined") return;
        if ($scope.floorplan.communities.length === 0) return;

        var price = $scope.floorplan.communities.reduce(function (min, c) {
          if (
            c.region_id == region_id ||
            (region_id == 1 && Math.floor(c.region_id / 10) == 1)
          ) {
            if (!min || (c.min_price > 0 && c.min_price < min)) {
              min = c.min_price;
            }
          }
          return min;
        }, 0);

        return price;
      };

      $scope.inRegion = function (region_id) {
        if (typeof $scope.floorplan === "undefined") return;
        if (typeof $scope.floorplan.communities === "undefined") return;
        if ($scope.floorplan.communities.length === 0) return;

        var exists = $scope.floorplan.communities.filter(function (c) {
          if (
            c.region_id == region_id ||
            (region_id == 1 && Math.floor(c.region_id / 10) == 1)
          ) {
            return true;
          }
          return false;
        });
        return !!exists.length;
      };

      $scope.setRegion = function (region_id) {
        var region_name = $scope.allRegions[region_id].name;
        var region_seo = $scope.allRegions[region_id].url;
        regionStorageFactory.set(region_name, region_seo);
        $scope.regionId = region_id;

        $scope.setPrice($scope.regionPrice(region_id));

        // $scope.floorplan.communities = $scope.floorplan.communities.filter(function (c) {
        //   return c.region_id == region_id;
        // });
      };
    },
  ]);
})();
